// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-product-modal-modal_card-jbQDU {
  width: 340px;
  min-height: 440px;
  height: auto;
}

.add-product-modal-textField_container-qhAE0, .add-product-modal-select-auWvX {
  width: 100%;
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/provider/products/add-product-modal/add-product-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 340px;\n  min-height: 440px;\n  height: auto;\n}\n\n.textField_container, .select {\n  width: 100%;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `add-product-modal-modal_card-jbQDU`,
	"textField_container": `add-product-modal-textField_container-qhAE0`,
	"select": `add-product-modal-select-auWvX`
};
export default ___CSS_LOADER_EXPORT___;
